module.exports = __webpack_public_path__ + "static/img/bg_desktop.10fe7a44.webp";